import BrowseCourier from "./BrowseCourier";
import DetailCourier from "./DetailCourier";
import CreateCourier from "./CreateCourier";

const CourierRoute = {
    BrowseCourier, DetailCourier, CreateCourier
}

export default CourierRoute